var render = function render(){var _vm=this,_c=_vm._self._c;return _c('licence-manager',{attrs:{"person":this.$route.params.id,"is-editable":_vm.isEditable},on:{"commitChanges":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }